const { createStore } = require('./Store');
const { ProfileReducer } = require('./Reducers');
const { ProfileState } = require('./States');
const { profileActions } = require('./Actions');

const [ProfileProvider, useProfileDispatch, useProfileStore] = createStore(
  ProfileReducer,
  ProfileState,
  profileActions
);
export { ProfileProvider, useProfileDispatch, useProfileStore };
